var map = {
	"./01.jpg": "N6G0",
	"./02.jpg": "e+hj",
	"./03.jpg": "Ezyk",
	"./04.jpg": "GOpJ",
	"./05.jpg": "JREj",
	"./06.jpg": "yUal"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Vm3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store ^\.\/.*\.jpg$
// module id = 1Vm3
// module chunks = 0